<template>
  <div :class="[
    'mask-img',
    {
      'mask-img-m': isMobile
    }
  ]">
    <div class="container">
      <img
        v-if="canvasImgUrl"
        crossorigin='anonymous'
        :src="canvasImgUrl"
        class="save-img"
      >
      <!-- <div class="top">
        <img
          :src="userInfo.avatar|serverimg_url('', 'avatar')"
          :onerror="errorImg"
          class="avatar"
        >
      </div>
      <div class="center">
        <p class="title">{{ userInfo.nickName }}</p>
        <img class="qr-img" :src="imgSrc">
        <p class="qr-img-tip">{{ $t('addfriend.downloadImg.scanCode') }}</p>
      </div> -->
    </div>
    <p v-if="isMobile" class="tip-text">{{ $t('addfriend.downloadImg.save') }}</p>
    <i class="eeo-icon-circle-close close"  @click="hideMask"></i>
    <div style="overflow: hidden; width: 0px; height: 0px;">
      <canvas
        ref="QRImageCanvas"
        id="myCanvas"
        width="1120px"
        height="1464px"
      >
        The device is not supported canvas.
      </canvas>
    </div>
  </div>
</template>

<script>
import moment_format from '@/filters/moment_format';
import serverimg_url from '@/filters/serverimg_url';
export default {
  name: 'mask-box',
  props: {
    userInfo: {
      type: Object,
      default: ()=>{}
    },
    sq: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isMobile: window.browserVersion.mobile,
      errorImg: 'this.src="' + require('@/assets/images/b/avatar_defalut.png') + '"',
      canvasImgUrl: '',
      errorCanvasImg: require('@/assets/images/b/avatar_defalut.png'),
    }
  },
  computed: {
    imgSrc() {
      const sq = encodeURIComponent(this.sq)
      let url = `https://${window.EEOENV.share.main}/s/b/?sq=${sq}`
      var encodeValue = encodeURIComponent(url)
      var srcStr =
        'https://' +
        window.EEOENV.hosts.dynamic +
        '/import/code/qrimg.php?size=6&level=L&tourl=' +
        encodeValue
      return srcStr
    },

  },
  filters: {
    serverimg_url,
    moment_format,
  },
  mounted() {
    this.$nextTick(()=>{
      this.drawImage()
    })
  },
  methods: {
    hideMask() {
      this.$emit('hide-mask')
    },
    drawImage() {
      const _this = this
      CanvasRenderingContext2D.prototype.render = function(
        textStr,
        config,
        isLine,
        isCut
      ) {
        var context = this
        var textStyle = {
          fontFamily:
            '\'Microsoft YaHei\', \'微软雅黑\', \'PingFang SC\', \'Helvetica Neue\', Helvetica, \'Hiragino Sans GB\', Arial, sans-serif',
          fontSize: '12px',
          color: '#000',
          textAlign: 'center',
          lineHeight: '12px',
        }
        var boxStyle = {
          width: 0,
          left: 0,
          top: 0,
        }
        if (config) {
          config.fontFamily !== undefined &&
            (textStyle.fontFamily = config.fontFamily)
          config.fontSize !== undefined &&
            ((textStyle.fontSize = config.fontSize),
            (textStyle.lineHeight = config.fontSize))
          config.color !== undefined && (textStyle.color = config.color)
          config.textAlign !== undefined &&
            (textStyle.textAlign = config.textAlign)
          config.lineHeight !== undefined &&
            (textStyle.lineHeight = config.lineHeight)

          config.width !== undefined && (boxStyle.width = config.width)
          config.left !== undefined && (boxStyle.left = config.left)
          config.top !== undefined && (boxStyle.top = config.top)
        }
        var textStrArr = textStr.split('\n')
        var textLineArr = []
        textStrArr.map(function(lineStr) {
          if (isLine) {
            var lineStrArr = lineStr.split('')
            var prevLine = ''
            var testLine = ''
            let moreLen = false
            lineStrArr.map(function(v2, i2) {
              testLine = prevLine + v2
              var testLineWidth = context.measureText(testLine).width
              if (i2 > 0 && testLineWidth > boxStyle.width) {
                moreLen = true
                if (!isCut) {
                  textLineArr.push(prevLine)
                  prevLine = v2
                }
              } else {
                prevLine = testLine
              }
            })
            if (isCut && moreLen) {
              prevLine = prevLine + '...'
            }
            textLineArr.push(prevLine)
          } else {
            textLineArr.push(lineStr)
          }
        })
        var lineHeightNum = parseInt(textStyle.lineHeight)
        let top = boxStyle.top - ((textLineArr.length - 1) * lineHeightNum) / 2

        textLineArr.map(function(v, i) {
          context.font = textStyle.fontSize + ' ' + textStyle.fontFamily
          context.fillStyle = textStyle.color
          context.textAlign = textStyle.textAlign
          context.textBaseline = 'top'

          context.fillText(v, boxStyle.left, top + lineHeightNum * i)
        })
      }
      // const canvas = document.getElementById('myCanvas')
      const canvas = this.$refs.QRImageCanvas
      if (canvas && canvas.getContext) {
        const ctx = canvas.getContext('2d')
        const topImg = require('@/assets/images/a/top.png')
        const userImg = this.userInfo.avatar
          ? serverimg_url(this.userInfo.avatar, '', 'avatar') + '?c=1'
          : this.errorCanvasImg
        ctx.fillStyle="#ffffff";
        ctx.fillRect(0, 0, 560*2, 732*2);

        const _topImg = new Image()
        _topImg.crossOrigin = 'Anonymous'
        _topImg.src = topImg
        _topImg.onload = () => {
          ctx.drawImage(_topImg, 0,0,560*2,226*2)
          ctx.save();
          ctx.globalCompositeOperation = 'source-over'
          const _userImg = new Image()
          _userImg.crossOrigin = 'Anonymous'
          _userImg.src = userImg
          _userImg.onerror = () => {
             _userImg.src = this.errorCanvasImg
          }
          _userImg.onload = () => {
            // 绘制用户头像（圆形头像）
            ctx.arc(281*2, 226*2, 45*2, 0, 2 * Math.PI);    //剪切操作 将正方形的头像切成圆的
            // 从画布上裁剪出这个圆形
            ctx.clip();
            ctx.drawImage(_userImg, 236*2, 181*2, 90*2, 90*2)
            ctx.restore();

            const textMaxWidth = 496*2
            // 绘制用户昵称
            ctx.font = '500 64px PingFang SC'
            ctx.render(
              this.userInfo.nickName,
              {
                fontSize: '64px',
                color: '#000',
                lineHeight: '72px',
                textAlign: 'center',
                left: 280*2,
                top: 295*2,
                width: textMaxWidth,
              },
              true,
              true
            )
            // 绘制扫码提示
            ctx.render(
              this.$t('addfriend.downloadImg.scanCode'),
              {
                fontSize: '48px',
                color: '#B1B1B1',
                lineHeight: '72px',
                textAlign: 'center',
                left: 280*2,
                top: 639*2,
                width: textMaxWidth,
              },
              true,
              true
            )
            
            // 绘制二维码
            const qr_img = new Image()
            qr_img.crossOrigin = 'Anonymous'
            qr_img.src = this.imgSrc
            qr_img.onload = () => {
              ctx.drawImage(qr_img, 176*2, 391*2, 208*2, 208*2)
              _this.canvasImgUrl = canvas.toDataURL("image/png")
            }
          }
        }
      }
    },
  },
}
</script>

<style lang="less" scoped>
  .mask-img {
    position: fixed;
    z-index: 10;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(0,0,0,.6);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .container {
      display: flex;
      flex-direction: column;
      width: 280px;
      height: 366px;
      border-radius: 4px;
      overflow: hidden;
      position: relative;
      .save-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
    .tip-text {
      margin-top: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }
    .close {
      margin-top: 15px;
      color: #fff;
      font-size: 30px;
      cursor: pointer;
    }

    &.mask-img-m {
      .container {
        width: 560px;
        height: 732px;
        border-radius: 8px;
      }
      .tip-text {
        margin-top: 48px;
        font-size: 28px;
      }
      .close {
        margin-top: 30px;
        font-size: 60px;
      }
    }
  }
</style>